import cn from "classnames";
import React, {
  ChangeEvent,
  KeyboardEvent,
  ReactNode,
  useEffect,
  useState,
} from "react";
// import queryString from "query-string";

import {
  Button,
  IconTimes,
  IconSearch,
  Input,
} from "@infologistics/frontend-libraries";

import {
  // createUrl,
  getParamsFromSearch,
  getSortedParams,
} from "@utils/utils";

import {
  // FilterName,
  InputStringLength,
  Key,
  // SearchStrLength, Section
} from "@const/consts";

// import { IParams } from '@store/types/commonTypes'
import {
  IQueryLikeFilterProps as IProps,
  // IQueryLikeFilterState as IState
} from "./types";

import styles from "./QueryLikeFilter.module.css";
import { useLocation, useNavigate } from "react-router";
import { IParams } from "@app/types";
import { FilterName } from "@app/const/filters";
import { setSearchContext } from "@app/store/modules/utils";
import { useAppDispatch } from "@app/hooks/redux";

export const QueryLikeFilter = (props: IProps) => {
  const {
    className,
    inputPattern,
    // onChangeSearchValue,
    placeholder,
    // userFilter,
    skipToFirstPage,
  } = props;

  const [isApplied, setIsApplied] = useState(false);
  const [value, setValue] = useState("");

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    const params = {
      ...getParamsFromSearch(location.search),
    };

    if (params.hasOwnProperty(FilterName.QUERY_LIKE)) {
      const value = params[FilterName.QUERY_LIKE];

      setIsApplied(true);
      setValue(value);

      const searchStr = value
        .split(/,| /)
        .filter((item: string) => item.length >= InputStringLength.MIN);
      dispatch(setSearchContext(searchStr));
    } else {
      dispatch(setSearchContext([]));
    }
  }, []);

  const getParams = (value: string): IParams => {
    const params = getParamsFromSearch(location.search);

    if (value) {
      return {
        ...params,
        [FilterName.QUERY_LIKE]: value.trim(),
      };
    }

    delete params[FilterName.QUERY_LIKE];

    return params;
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>): void => {
    const { value } = e.target;

    if (inputPattern && !value.match(inputPattern)) return;

    setValue(value);
  };

  const handleEnter = (e: KeyboardEvent<HTMLInputElement>): void => {
    if (e.key === Key.ENTER) {
      handleSubmitFilter()();
    }
  };

  const handleReset = (): void => {
    setValue("");
    handleSubmitFilter("")();
  };

  const renderResetButton = (): ReactNode => {
    return (
      isApplied && (
        <Button
          externalClass={cn(styles.button, styles.button_reset)}
          theme="text"
          onClick={handleReset}
        >
          <IconTimes color="gray-500" />
        </Button>
      )
    );
  };

  const handleSubmitFilter = (myValue?: string) => (): void => {
    const newValue = myValue ?? value;

    if (!isApplied && !newValue) return;

    if (!newValue) {
      setIsApplied(false);
    } else {
      setIsApplied(true);
    }

    const params = getParams(newValue);
    skipToFirstPage && (params.page = 1);

    // const queryParams = userFilter ? (
    //   { ...params, ...queryString.parse(userFilter.params) }
    // ) : (
    //   { ...params }
    // )
    const queryParams = { ...params };

    const query = getSortedParams(queryParams);

    // const path = userFilter && params
    //   ? createUrl(match, Section.DOCUMENTS_ALL)
    //   : location.pathname
    const path = location.pathname;

    const searchStr = newValue
      .split(/,| /)
      .filter((item: string) => item.length >= InputStringLength.MIN);
    dispatch(setSearchContext(searchStr));

    // history.replace(`${path}?${query}`)
    navigate(`${path}?${query}`, { replace: true });
  };

  return (
    <div className={cn(styles.filter, className)}>
      <Button
        externalClass={cn(styles.button, styles.button_search)}
        theme="text"
        onClick={handleSubmitFilter()}
      >
        <IconSearch />
      </Button>
      <Input
        classes={{
          input: styles.input_control,
          wrapper: styles.input,
        }}
        name=""
        maxLength={InputStringLength.MAX}
        onChange={handleChange}
        onKeyDown={handleEnter}
        placeholder={placeholder}
        value={value}
      />
      {renderResetButton()}
    </div>
  );
};
